<script>
  import MemoryListItem from "../MemoryComponents/MemoryListItem.svelte";
  import {onMount} from "svelte";
  import {preFetchMemories, CacheLoadState} from "../AppState/Cache";
  import BylinePlaceholder from "../Elemental Components/BylinePlaceholder.svelte";

  let cacheState = CacheLoadState.loading
  onMount(() => {
    preFetchMemories([
        '944708B7-8014-40B8-A8A0-D32ACA578F76',
        'AC147407-A47D-4A2F-9848-86CCA467ED26',
        'CBC2CCD1-D0C2-4DEC-A226-A0AA176C13C0',
        '5D41C3E4-2FFF-4400-988E-0C1BE327495A',
        '7FF20961-463C-4BC9-A618-F80218B5FA69',
        'C4915D0E-2828-4092-86A0-78C9F2021C84',
        '17178F95-082E-4D5F-8D6A-F5771030F8D0',
        '502809B4-AF10-42FA-B6B3-9B126D3E965F',
        '5589338A-0E8A-45A2-97B4-E4FE9108845E',
    ],
      (state) => {
        cacheState = state
      })
  })
</script>

<main>
  {#if cacheState === CacheLoadState.loading}
    <p>loading</p>
  {:else if cacheState === CacheLoadState.failed}
    <p>something went wrong</p>
  {:else if cacheState === CacheLoadState.found}
    <MemoryListItem memoryUUID='944708B7-8014-40B8-A8A0-D32ACA578F76'/> <!-- Cody's First Road Trip  -->
    <dividerLine/>
    <MemoryListItem memoryUUID='AC147407-A47D-4A2F-9848-86CCA467ED26'/> <!-- Co-Pilot -->
    <dividerLine/>
    <MemoryListItem memoryUUID='CBC2CCD1-D0C2-4DEC-A226-A0AA176C13C0'/> <!-- Cody Meets Rocket -->
    <dividerLine/>
    <MemoryListItem memoryUUID='5D41C3E4-2FFF-4400-988E-0C1BE327495A'/> <!-- Eldo -->
    <dividerLine/>
    <MemoryListItem memoryUUID='7FF20961-463C-4BC9-A618-F80218B5FA69'/> <!-- Naptime -->
    <dividerLine/>
    <MemoryListItem memoryUUID='C4915D0E-2828-4092-86A0-78C9F2021C84'/> <!-- 4th of July -->
    <dividerLine/>
    <MemoryListItem memoryUUID='17178F95-082E-4D5F-8D6A-F5771030F8D0'/> <!-- Colorado Prarie -->
    <dividerLine/>
    <MemoryListItem memoryUUID='502809B4-AF10-42FA-B6B3-9B126D3E965F'/> <!-- Young Puppy Pals -->
    <dividerLine/>
    <MemoryListItem memoryUUID='5589338A-0E8A-45A2-97B4-E4FE9108845E'/> <!-- First Cherry Creek Dog Park Trip -->
  {/if}
</main>

<style>
  main {
    max-width: 2000px;
    text-align: left;
  }
  main h2 {
    text-align: left;
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
  p {
    margin-top: 30px;
  }

  dividerLine {
    background-color: rgba(107,118,141,0.3);
    width: 300px;
    height: 100px;
    margin-top: 20px;
    margin-bottom:20px;
  }
</style>